// extracted by mini-css-extract-plugin
module.exports = {"submitedTag":"antd-pro-utils-common-submitedTag"};
    if(module.hot) {
      // 1793347664819
      var cssReload = require("/home/ship/linein-platform/apps/linein-console/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"/","hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  